document.addEventListener('DOMContentLoaded', function() {
      const submenuImages = {
        "femme__pantalons": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/menu_F_pantalons.jpg?v=1756841408",
        "femme__shorts": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/Menu_Short_Femme.jpg?v=1758283709",
        "femme__t-shirts": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/Menu_T-Shirt_Femme.jpg?v=1758283710",
        "femme__sweats-et-vestes": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/Menu_Sweat_Femme.jpg?v=1758283710",
        "femme__voir-tout": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/menu_tout.jpg?v=1756840054",
        "femme__legging-brassiere": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/menu_F_legging.jpg?v=1756841408",
        "femme__accessoires": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/menu_F_acess.jpg?v=1756841408",
        "femme__laila-peak": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/menu_laila_80f492c3-1a1b-4e3c-8d69-b834ead44f55.jpg?v=1758752113",
        
        "homme__fitz-roy": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/Menu_Fitz_Roy.jpg?v=1758283710",
        "homme__pantalons": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/Menu_Pantalons_Homme.jpg?v=1758283709",
        "homme__t-shirts": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/Menu_T-Shirt_Homme.jpg?v=1758283709",
        "homme__shorts": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/Menu_Short_Homme.jpg?v=1758283709",
        "homme__sweats-et-vestes": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/Menu_Sweat_Homme.jpg?v=1758283709",
        "homme__accessoires": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/menu_acess.jpg?v=1756840661",
        "homme__voir-tout": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/menu_tout.jpg?v=1756840054",

        "notre-univers__la-marque": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/la-marque.png?v=1763654001",
        "notre-univers__blog": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/menu_blog.jpg?v=1758764409",
        "notre-univers__trouver-un-magasin": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/menu_magazin.jpg?v=1758764409",
        "notre-univers__contact": "https://cdn.shopify.com/s/files/1/0618/2082/9939/files/menu_contact.jpg?v=1758764410",
      };

      document.querySelectorAll('.new-submenu').forEach(submenu => {
        const images = submenu.querySelectorAll('.mega-menu__left img');
        const links = submenu.querySelectorAll('.sub-links a');

        // Define src das imagens
        images.forEach(img => {
          const key = img.getAttribute('data-target');
          if(submenuImages[key]) img.src = submenuImages[key];
        });

        // Mostra a primeira imagem por padrão
        if(images[0]) images[0].style.display = 'block';
        let defaultImg = images[0];

        links.forEach(link => {
          link.addEventListener('mouseenter', () => {
            const key = link.getAttribute('data-target');
            images.forEach(img => img.style.display = 'none'); // esconde todas
            const imgToShow = submenu.querySelector(`.mega-menu__left img[data-target="${key}"]`);
            if(imgToShow) imgToShow.style.display = 'block';
          });

          link.addEventListener('mouseleave', () => {
            images.forEach(img => img.style.display = 'none'); // esconde todas
            if(defaultImg) defaultImg.style.display = 'block';   // mostra a padrão
          });
        });
      });
    });


document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper(".best-sellers-carousel", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
        el: ".swiper-pagination",
        type: "fraction",
        },
        navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("open-filters");
  const closeBtn = document.getElementById("close-filters");
  const overlay = document.getElementById("filters-overlay");

  openBtn.addEventListener("click", () => {
    document.body.classList.add("filters-open");
  });

  closeBtn.addEventListener("click", () => {
    document.body.classList.remove("filters-open");
  });

  overlay.addEventListener("click", () => {
    document.body.classList.remove("filters-open");
  });

  // Fecha com ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      document.body.classList.remove("filters-open");
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("custom-search-input");
  const resultsBox = document.getElementById("custom-search-results");

  input.addEventListener("input", function () {
    const query = this.value.trim();

    if (query.length < 3) {
      resultsBox.innerHTML = "";
      return;
    }

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
      .then(res => res.json())
      .then(data => {
        const products = data.resources.results.products;
        if (products.length) {
          resultsBox.innerHTML = `
            <ul class="custom-search-list">
              ${products.map(p => `
                <li>
                  <a href="${p.url}">
                    <img src="${p.image}" alt="${p.title}">
                    <div class="info">
                      <div class="titulo">${p.title}</div>
                      <p><strong>${p.price}</strong></p>
                    </div>
                  </a>
                </li>
              `).join("")}
            </ul>
          `;
        } else {
          resultsBox.innerHTML = "<p>Aucun produit trouvé</p>";
        }
      })
      .catch(err => console.error("Erreur de recherche:", err));
  });
});


  